function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 25.433,
  height: 25,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 2,
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  result: "blur"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.302
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "blur"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  id: "Path_7",
  x: 14.56,
  y: 0.776,
  width: 17.373,
  height: 23.447,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 2,
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  result: "blur-2"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.302
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "blur-2"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1638",
  "data-name": "Group 1638",
  transform: "translate(-1143 -744)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, 1143, 747)",
  filter: "url(#Rectangle)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2",
  "data-name": "Rectangle",
  width: 13.433,
  height: 13,
  rx: 2,
  transform: "translate(6 4)",
  fill: "#25a4b4"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, 1143, 747)",
  filter: "url(#Path_7)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_7-2",
  "data-name": "Path 7",
  d: "M0,4.032a.855.855,0,0,1,.4-.718l3.582-2.3a.9.9,0,0,1,1.392.718V11.45a.9.9,0,0,1-1.392.718L.4,9.867A.855.855,0,0,1,0,9.149Z",
  transform: "translate(20.56 3.91)",
  fill: "#25a4b4"
})));

var SvgVideoMedia = function SvgVideoMedia(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31.933,
    height: 25,
    viewBox: "0 0 31.933 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVideoMedia, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/video-media.ebebbb5e.svg";
export { ForwardRef as ReactComponent };